
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface CourierActivityProgressBarProps {
  repeatedPayments: number;
  maxTarget?: number;
}

const CourierActivityProgressBar: React.FC<CourierActivityProgressBarProps> = ({ 
  repeatedPayments, 
  maxTarget = 6 
}) => {
  const percentage = Math.min((repeatedPayments / maxTarget) * 100, 100);
  
  // Определяем цвет на основе количества повторных платежей
  const getProgressColor = (payments: number) => {
    if (payments >= 5) return 'bg-emerald-600';
    if (payments >= 4) return 'bg-green-500';
    if (payments >= 2) return 'bg-yellow-500';
    if (payments >= 1) return 'bg-orange-500';
    return 'bg-red-600';
  };

  return (
    <div className="w-full space-y-1">
      <div className="relative">
        <Progress 
          value={percentage} 
          className="h-3 bg-gray-200 dark:bg-gray-700"
        />
        <div 
          className={`absolute top-0 left-0 h-3 rounded-full transition-all ${getProgressColor(repeatedPayments)} shadow-sm`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <div className="text-xs font-semibold text-center">
        {percentage.toFixed(1)}%
      </div>
    </div>
  );
};

export default CourierActivityProgressBar;
